import RiskLayout from "./RiskLayout";
export default function RRiskLayout() {
  return <RiskLayout basePath="/partner/portfoliomanagement/r/risk" />;
}
